import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useProfileContext } from "context";
import { updateAIAssistantSettings } from "api/bAIAssistantApi";

export function useUpdateAIAssistantSettings() {
  const queryClient = useQueryClient();
  const { userProfile } = useProfileContext();
  const key = ["ai-assistant", userProfile?.organisation_id, userProfile?.user_id];
  return useMutation({
    mutationFn: updateAIAssistantSettings,
    retry: false,
    onSuccess: (data) => queryClient.setQueryData([...key, "settings"], data),
    onError: (error) => {
      const data = error.response?.data?.settings;
      if (data) queryClient.setQueryData([...key, "settings"], data);
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: key }),
  });
}
